import { addHocItem } from "@/api/deduction-items";
import Dropdown, { Item } from "@/components/form/Dropdown";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import {
  DeductionItem,
  DeductionItemType,
  DeductionItemTypeLabels,
} from "@/models/deduction-items.model";
import React, { useState } from "react";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
  updateDeductionItems: (item: DeductionItem) => void;
}

export const deductionItemTypeArray: Item[] = Object.values(
  DeductionItemType
).map((value) => ({
  value: value,
  label: DeductionItemTypeLabels[value],
}));

function AddDeductionForm({
  userId,
  month,
  year,
  payslipId,
  updateDeductionItems,
}: Props) {
  const [type, setType] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [err, setErr] = useState<string>("");
  const isValid = () => {
    if (type === "" || amount === 0) {
      setErr("Please fill all fields.");
      return false;
    }
    if (amount <= 0) {
      setErr("Amount must be greater than 0.");
      return false;
    }
    setErr("");
    return true;
  };

  const handleDeductionItem = async () => {
    if (!isValid()) {
      return;
    }
    // Add deduction item
    try {
      const deductionItem = await addHocItem({
        amount,
        type: type as DeductionItemType,
        userId,
        month,
        year,
        payslipId,
      });
      updateDeductionItems(deductionItem);
      if (deductionItem) {
        toast({
          title: "Deduction item added",
          description: `Deduction item ${
            DeductionItemTypeLabels[type as DeductionItemType]
          } added successfully`,
        });
        setErr("");
        setType("");
        setAmount(0);
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to add deduction item",
        variant: "destructive",
      });
    }
  };
  return (
    <div className="flex gap-2 flex-col mt-3">
      <div className="flex gap-2 items-end">
        <Dropdown
          label="Type"
          items={deductionItemTypeArray}
          selectedString={type}
          setSelectedString={setType}
        />
        <NumberInput
          label="Amount"
          value={amount}
          setValue={setAmount}
          placeholder="Amount"
        />
        <Button onClick={handleDeductionItem} type="submit">
          Add
        </Button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
    </div>
  );
}

export default AddDeductionForm;
